import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

function Register() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    epost: '',
    passord: '',
    passordBekreft: '',
    navn: '',
    telefon: '',
    firma: '',
    org_nr: '',
    adresse: '',
    postnr: '',
    poststed: '',
    epost_firma: '',
    nettside: '',
    sertifikat_nr: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Valider passord
    if (formData.passord !== formData.passordBekreft) {
      setError('Passordene er ikke like');
      return;
    }

    if (formData.passord.length < 6) {
      setError('Passordet må være minst 6 tegn');
      return;
    }

    setLoading(true);

    const result = await register({
      epost: formData.epost,
      passord: formData.passord,
      navn: formData.navn,
      telefon: formData.telefon,
      firma: formData.firma,
      org_nr: formData.org_nr,
      adresse: formData.adresse,
      postnr: formData.postnr,
      poststed: formData.poststed,
      epost_firma: formData.epost_firma,
      nettside: formData.nettside,
      sertifikat_nr: formData.sertifikat_nr,
    });

    if (result.success) {
      // Automatisk innlogging etter registrering
      navigate('/dashboard');
    } else {
      setError(result.error || 'Kunne ikke opprette bruker');
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Takstmann System</h1>
        <h2>Registrer ny bruker</h2>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="navn">Navn *</label>
            <input
              type="text"
              id="navn"
              name="navn"
              value={formData.navn}
              onChange={handleChange}
              required
              placeholder="Ola Nordmann"
            />
          </div>

          <div className="form-group">
            <label htmlFor="epost">E-post *</label>
            <input
              type="email"
              id="epost"
              name="epost"
              value={formData.epost}
              onChange={handleChange}
              required
              placeholder="ola@takstfirma.no"
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="telefon">Telefon</label>
            <input
              type="tel"
              id="telefon"
              name="telefon"
              value={formData.telefon}
              onChange={handleChange}
              placeholder="98765432"
            />
          </div>

          <div className="form-group">
            <label htmlFor="firma">Firma</label>
            <input
              type="text"
              id="firma"
              name="firma"
              value={formData.firma}
              onChange={handleChange}
              placeholder="Takst AS"
            />
          </div>

          <div className="form-group">
            <label htmlFor="org_nr">Organisasjonsnummer</label>
            <input
              type="text"
              id="org_nr"
              name="org_nr"
              value={formData.org_nr}
              onChange={handleChange}
              placeholder="123456789"
            />
          </div>

          <div className="form-group">
            <label htmlFor="adresse">Adresse</label>
            <input
              type="text"
              id="adresse"
              name="adresse"
              value={formData.adresse}
              onChange={handleChange}
              placeholder="Storgata 1"
            />
          </div>

          <div className="form-group">
            <label htmlFor="postnr">Postnummer</label>
            <input
              type="text"
              id="postnr"
              name="postnr"
              value={formData.postnr}
              onChange={handleChange}
              placeholder="0123"
            />
          </div>

          <div className="form-group">
            <label htmlFor="poststed">Poststed</label>
            <input
              type="text"
              id="poststed"
              name="poststed"
              value={formData.poststed}
              onChange={handleChange}
              placeholder="Oslo"
            />
          </div>

          <div className="form-group">
            <label htmlFor="epost_firma">Firma e-post</label>
            <input
              type="email"
              id="epost_firma"
              name="epost_firma"
              value={formData.epost_firma}
              onChange={handleChange}
              placeholder="post@takstfirma.no"
            />
          </div>

          <div className="form-group">
            <label htmlFor="nettside">Nettside</label>
            <input
              type="url"
              id="nettside"
              name="nettside"
              value={formData.nettside}
              onChange={handleChange}
              placeholder="https://www.takstfirma.no"
            />
          </div>

          <div className="form-group">
            <label htmlFor="sertifikat_nr">Sertifikatnummer</label>
            <input
              type="text"
              id="sertifikat_nr"
              name="sertifikat_nr"
              value={formData.sertifikat_nr}
              onChange={handleChange}
              placeholder="CERT-2024-001"
            />
          </div>

          <div className="form-group">
            <label htmlFor="passord">Passord *</label>
            <input
              type="password"
              id="passord"
              name="passord"
              value={formData.passord}
              onChange={handleChange}
              required
              minLength="6"
              placeholder="Minimum 6 tegn"
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="passordBekreft">Bekreft passord *</label>
            <input
              type="password"
              id="passordBekreft"
              name="passordBekreft"
              value={formData.passordBekreft}
              onChange={handleChange}
              required
              minLength="6"
              placeholder="Skriv passordet igjen"
              autoComplete="new-password"
            />
          </div>

          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Oppretter bruker...' : 'Registrer'}
          </button>
        </form>

        <p className="register-link">
          Har du allerede konto? <Link to="/login">Logg inn her</Link>
        </p>
      </div>
    </div>
  );
}

export default Register;
